import { Node } from '@tiptap/core'
import { sharedAttrs } from '../shared/shared-attrs'

export const FilledPlaceholder = Node.create({
  name: 'filled_placeholder',

  group: 'inline',
  inline: true,
  content: 'text*',

  addAttributes() {
    return { ...this.parent?.(), ...sharedAttrs }
  },

  addOptions() {
    return {
      HTMLAttributes: {},
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['span', HTMLAttributes, 0]
  },
})
